export const OAB_ELIGIBILITY_QUERY_KEY = ['oabEligibility'] as const;
